/**
 * Configuración del endpoint de la API para MagicMail.
 * En web normal se usa '/api'.
 * En la app móvil (Capacitor/Android) viene configurado por defecto con:
 * https://correo.reneworks.mx/api
 *
 * El usuario puede personalizar el servidor en cualquier momento desde la pantalla de
 * inicio de sesión o configuración, guardándolo en localStorage.
 */

export const DEFAULT_API_URL = "https://correo.reneworks.mx/api";
export const STORAGE_CUSTOM_API_KEY = "magicmail_custom_api_url";

export function isMobileNative(): boolean {
  if (typeof window === "undefined") return false;
  return (
    (window as any).Capacitor !== undefined ||
    window.location.protocol === "capacitor:" ||
    (window.location.hostname === "localhost" && window.location.port === "")
  );
}

export function getCustomApiBaseUrl(): string | null {
  if (typeof window === "undefined") return null;
  const custom = localStorage.getItem(STORAGE_CUSTOM_API_KEY);
  return custom ? custom.trim().replace(/\/$/, "") : null;
}

export function setCustomApiBaseUrl(url: string | null): void {
  if (typeof window === "undefined") return;
  if (!url || !url.trim()) {
    localStorage.removeItem(STORAGE_CUSTOM_API_KEY);
  } else {
    let clean = url.trim().replace(/\/$/, "");
    if (!clean.startsWith("http://") && !clean.startsWith("https://")) {
      clean = `https://${clean}`;
    }
    // Asegurar que termine en /api si no lo incluye
    if (!clean.endsWith("/api")) {
      clean = `${clean}/api`;
    }
    localStorage.setItem(STORAGE_CUSTOM_API_KEY, clean);
  }
}

export function getApiBaseUrl(): string {
  // 1. Endpoint personalizado por el usuario (útil en móvil o para servidor propio)
  const custom = getCustomApiBaseUrl();
  if (custom) {
    return custom;
  }

  // 2. Variable de entorno explícita en build
  if (import.meta.env.VITE_API_URL) {
    return (import.meta.env.VITE_API_URL as string).replace(/\/$/, "");
  }

  // 3. Entorno Capacitor / Android WebView: servidor por defecto
  if (isMobileNative()) {
    return DEFAULT_API_URL;
  }

  // 4. Navegador web estándar
  return "/api";
}
